// Helper function to extract district from city name
export const extractDistrictFromCity = (cityName) => {
  if (cityName.includes('Budapest') && cityName.includes('kerület')) {
    const match = cityName.match(/Budapest\s+([IVXLC]+)\.\s+kerület/);
    if (match) {
      return match[1] + '. kerület';
    }
  }
  return '';
};

// Helper function to format city and district display without duplication
export const formatCityDisplay = (city, district) => {
  if (city && city.includes('kerület')) {
    return city;
  }
  if (city && district) {
    return `${city}, ${district}`;
  }
  return city || '';
};

// Anti-scraping contact data helpers
export const truncatePhone = (phone) => {
  if (!phone) return '';
  return phone.substring(0, 5) + '...';
};

export const truncateEmail = (email) => {
  if (!email) return '';
  const atIndex = email.indexOf('@');
  if (atIndex > 0) {
    return email.substring(0, atIndex + 1) + '...';
  }
  return email.substring(0, 3) + '...';
};

// Calculate read time for blog posts
export const calculateReadTime = (content) => {
  const wordsPerMinute = 200;
  const words = content.split(' ').length;
  const minutes = Math.ceil(words / wordsPerMinute);
  return minutes;
};

// SEO-friendly URL generation
export const generateClinicSlug = (clinic) => {
  const cleanText = (text) => {
    return text
      .toLowerCase()
      .replace(/[áäàâã]/g, 'a')
      .replace(/[éëèê]/g, 'e')
      .replace(/[íïìî]/g, 'i')
      .replace(/[óöòôõ]/g, 'o')
      .replace(/[úüùû]/g, 'u')
      .replace(/[ý]/g, 'y')
      .replace(/[ñ]/g, 'n')
      .replace(/[ç]/g, 'c')
      .replace(/[ő]/g, 'o')
      .replace(/[ű]/g, 'u')
      .replace(/[^a-z0-9]/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  };

  let slug = 'fogorvos';
  
  if (clinic.city) {
    slug += '-' + cleanText(clinic.city);
  }
  
  if (clinic.district) {
    let district = clinic.district.toLowerCase();
    const romanToArabic = {
      'xxiii.': '23', 'xxii.': '22', 'xxi.': '21', 'xx.': '20', 'xix.': '19', 'xviii.': '18', 'xvii.': '17', 'xvi.': '16', 'xv.': '15', 'xiv.': '14', 'xiii.': '13', 'xii.': '12', 'xi.': '11', 'x.': '10', 'ix.': '9', 'viii.': '8', 'vii.': '7', 'vi.': '6', 'v.': '5', 'iv.': '4', 'iii.': '3', 'ii.': '2', 'i.': '1'
    };
    
    let foundRoman = false;
    for (const [roman, arabic] of Object.entries(romanToArabic)) {
      if (district.includes(roman.replace('.', '. '))) {
        slug += '-' + arabic + '-kerulet';
        foundRoman = true;
        break;
      }
    }
    
    if (!foundRoman && district.includes('kerület')) {
      const match = district.match(/(\d+).*kerület/);
      if (match) {
        slug += '-' + match[1] + '-kerulet';
      }
    }
  }
  
  if (clinic.name) {
    slug += '-' + cleanText(clinic.name);
  }
  
  return slug;
};

// Parse SEO-friendly URL back to search for clinic
export const parseClinicSlug = (slug) => {
  const parts = slug.split('-');
  const parsed = {
    city: '',
    district: '',
    name: ''
  };
  
  let cityIndex = parts.indexOf('fogorvos') + 1;
  if (cityIndex < parts.length) {
    parsed.city = parts[cityIndex];
  }
  
  for (let i = 0; i < parts.length - 1; i++) {
    if (/^\d+$/.test(parts[i]) && parts[i + 1] === 'kerulet') {
      parsed.district = parts[i] + '. kerület';
      break;
    }
  }
  
  let nameStartIndex = cityIndex + 1;
  if (parsed.district) {
    nameStartIndex = parts.findIndex(p => p === 'kerulet') + 1;
  }
  
  if (nameStartIndex < parts.length) {
    parsed.name = parts.slice(nameStartIndex).join('-');
  }
  
  return parsed;
};
